import {
  Locales,
  LocaleMessages,
  ServerConfig,
  RequestUser
} from 'shared-types';
import { canUserCustomAttributeBeViewed } from '../customAttributes';

type Params = {
  language?: Locales;
  messages: LocaleMessages;
  serverConfig: ServerConfig<'admin'>;
} & (
  | {
      excludeUserCustomAttributes?: never | undefined;
      requestUser: RequestUser;
    }
  | {
      excludeUserCustomAttributes: true;
      requestUser?: never | undefined;
    }
);

const getExcelUserColumnOptions = ({
  excludeUserCustomAttributes,
  language,
  messages,
  requestUser,
  serverConfig
}: Params) => {
  const customAttributeOptions: { [key: string]: string } = {};

  (serverConfig.userCustomAttributes || [])
    .filter(
      (attribute) =>
        !attribute.excludeFromExcelExport &&
        !excludeUserCustomAttributes &&
        canUserCustomAttributeBeViewed({
          user: requestUser,
          userCustomAttribute: attribute
        })
    )
    .forEach((attribute) => {
      customAttributeOptions[`user.customAttributes.${attribute.key}`] =
        attribute.titleTranslations?.[
          language || serverConfig.defaultSystemLanguage
        ] || attribute.title;
    });

  return {
    'user.email': messages.commonEmail,
    'user.username': messages.commonUsername,
    'user.firstName': messages.usersFirstName,
    'user.lastName': messages.usersLastName,
    'user.createdAt': messages.usersAccountCreated,
    'user.lastLogin': messages.usersLastLogin,
    'user.groups': messages.commonGroups,
    ...customAttributeOptions
  };
};

export default getExcelUserColumnOptions;
